import * as React from "react";
import { Form, Row, Col } from "antd";
import "./documents-analysis.scss";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import PreFraudButton from 'src/components/common/PreFraudView/ViewPreFraudButton';
import { GetPersonType, PersonTypeEnum } from 'src/util/GetPersonType';

const DocumentsAnalysis = (props: any) => {
  const personType = () => GetPersonType(props.trade?.tradeOwner?.cpfCnpj);


  return (
    <div className="steps-container">
      <h1>Análise dos Dados</h1>
      {personType() === PersonTypeEnum.PJ ? (
        <div className="steps-container-description">
          <p>Nossa equipe analisará os dados do cliente.</p>
          <p>Assim que a análise for concluída, entraremos em contato para assinatura do termo de cessão digital.</p>
        </div>
      ) : (
          <div className="steps-container-description">
            <p>Nossa equipe analisará os os dados do cliente e para que a análise seja concluida o cliente deverá realizar uma selfie através do link no botão abaixo.</p>
            <PreFraudButton trade={props.trade} />
            <p>Assim que o cliente realizar a selfie e a análise for concluída, entraremos em contato para assinatura do termo de cessão digital.</p>
          </div>
        )}
      <Row>
        <Col xs={24} sm={24} md={8} lg={8}>
          <a target="_blank" href="https://blog.precatoriosbrasil.com/">
            <StandardButton style={{ maxWidth: "324px" }}>Ir para o Blog</StandardButton>
          </a>
        </Col>
        <Col xs={24} sm={24} md={2} lg={2} />
        <Col xs={24} sm={24} md={8} lg={8}>
          <a target="_blank" href="https://precatoriosbrasil.com/faq">
            <StandardButton preset="outline">FAQ</StandardButton>
          </a>
        </Col>
      </Row>
    </div>
  );
};

export default Form.create()(DocumentsAnalysis);



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/documents-analysis/DocumentsAnalysis.tsx